import { useNavigate } from 'react-router-dom'

// Category mapping for navigation
const categoryMap = {
  Birthday: '/birthday-category',
  College: '/college-category',
  Vacation: '/vacation-category',
  Wedding: '/wedding-category',
  'Friends & Family': '/friends-family-category',
  Pets: '/pets-category',
  'Events & Locations': '/events-locations-category',
  'Custom Category': '/custom-category'
}

export const useHeaderNavigation = () => {
  const navigate = useNavigate()

  const handleNavigation = (e, target) => {
    e.stopPropagation()
    e.preventDefault()
    // Clear gallery state cache so /gallery starts at level 1
    if (target === '/gallery') {
      try {
        const keysToRemove = []
        for (let i = 0; i < sessionStorage.length; i++) {
          const key = sessionStorage.key(i)
          if (key && key.includes('gallery_state')) {
            keysToRemove.push(key)
          }
        }
        keysToRemove.forEach(key => sessionStorage.removeItem(key))
      } catch (err) {
        // ignore
      }
    }
    navigate(target)
  }

  const handleKinNavigation = (e, category, onCloseMenus) => {
    e.stopPropagation()

    if (onCloseMenus) {
      onCloseMenus()
    }

    if (category === 'Build Your Own') {
      return
    } else {
      if (categoryMap[category]) {
        navigate(categoryMap[category])
      }
    }
  }

  const handleSignInNavigation = (e, target) => {
    e.stopPropagation()
    e.preventDefault()
    navigate(target)
  }

  const handleUploadClick = () => {
    navigate('/upload')
  }

  const handleDuplicatesClick = e => {
    e?.stopPropagation()
    navigate('/duplicates')
  }

  const handleFavoritesClick = () => {
    navigate('/favorites')
  }

  const handleDeletedClick = () => {
    navigate('/deleted')
  }

  const handleSubscribe = () => {
    navigate('/subscribe')
  }

  const handleLogoClick = () => {
    navigate('/gallery')
  }

  const handleKategoriesClick = event => {
    navigate('/kin-categories')
  }

  return {
    handleNavigation,
    handleKinNavigation,
    handleSignInNavigation,
    handleUploadClick,
    handleDuplicatesClick,
    handleFavoritesClick,
    handleDeletedClick,
    handleSubscribe,
    handleLogoClick,
    handleKategoriesClick,
    categoryMap
  }
}
